import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/teeth-whitening/hero";
import WhatAndWhy from "../components/teeth-whitening/what-and-why";
import Process from "../components/teeth-whitening/process";
import AfterCare from "../components/teeth-whitening/aftercare";
import CTA from "../components/teeth-whitening/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import QuestionsWhiten from "../components/teeth-whitening/Question";

function Index() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Teeth Whitening in Ilkley, West Yorkshire | Regent Dental",
    serviceType: "Teeth Whitening",
    url: "https://www.regent-dental.co.uk/teeth-whitening",
    description:
      "Teeth whitening services at Regent Dental offer a professional, safe, and effective way to achieve a brighter, whiter smile.",
    provider: {
      "@type": "LocalBusiness",
      "@id": "http://regent-dental.co.uk/#localbusiness",
      name: "Regent Dental",
      image:
        "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
      url: "http://regent-dental.co.uk/",
      telephone: "+01943 661331",
      openingHours: "Mo-Fr 09:00-17:00",
      priceRange: "$$",
      sameAs: [
        "https://www.facebook.com/people/Regent-Dental/61564954080373/",
        "https://www.instagram.com/regentdental_ilkley/",
        "https://g.co/kgs/EY9shTo",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "England",
        postalCode: "LS29 9EA",
        addressCountry: {
          "@type": "Country",
          name: "UK",
        },
      },
      areaServed: [
        { "@type": "Place", name: "Ilkley" },
        { "@type": "Place", name: "Keighley" },
        { "@type": "Place", name: "Skipton" },
        { "@type": "Place", name: "Otley" },
        { "@type": "Place", name: "Silsden" },
      ],
    },
  };

  return (
    <div>
      <Helmet>
        <title>Teeth Whitening in Ilkley, West Yorkshire | Regent Dental</title>
        <meta
          name="description"
          content="Brighten your smile with safe and professional teeth whitening in Ilkley. Regent Dental provides effective treatments for visibly whiter, more confident smiles."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/teeth-whitening"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <Navbar />
      <Header />
      <WhatAndWhy />
      <Process />
      <AfterCare />
      <QuestionsWhiten />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
